/**
 * ELV store-mode UTM. Copyright ELV Motors, Inc.
 * Active only when the current URL has utm_source=shopcodes.
 */
(() => {
  const KEY = 'utm_source';
  const VALUE = 'shopcodes';

  function isStoreMode() {
    try {
      return new URLSearchParams(window.location.search).get(KEY) === VALUE;
    } catch (e) {
      return false;
    }
  }

  function withParam(href) {
    if (!href || href.startsWith('#') || href.startsWith('javascript:')) return href;
    try {
      const url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return href;
      if (url.searchParams.get(KEY) === VALUE) return url.pathname + url.search + url.hash;
      url.searchParams.set(KEY, VALUE);
      return url.pathname + url.search + url.hash;
    } catch (e) {
      return href;
    }
  }

  function isProductOrSearchHref(href) {
    if (!href) return false;
    try {
      const url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return false;
      const path = url.pathname;
      return path.includes('/products/') || path === '/search' || path.endsWith('/search');
    } catch (e) {
      return false;
    }
  }

  function rewriteLinks(root) {
    if (!isStoreMode() || !root) return;
    root.querySelectorAll('a[href]').forEach((a) => {
      const href = a.getAttribute('href');
      if (!isProductOrSearchHref(href)) return;
      a.setAttribute('href', withParam(href));
    });
  }

  function injectSearchHiddenFields() {
    if (!isStoreMode()) return;
    document.querySelectorAll('form[role="search"]').forEach((form) => {
      if (form.querySelector(`input[name="${KEY}"][value="${VALUE}"]`)) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = KEY;
      input.value = VALUE;
      form.appendChild(input);
    });
  }

  window.elvShopcodes = {
    KEY,
    VALUE,
    isStoreMode,
    withParam,
    rewriteLinks,
    preserveInParams(searchParams) {
      if (!isStoreMode()) return searchParams;
      const params = new URLSearchParams(searchParams || '');
      if (params.get(KEY) !== VALUE) params.set(KEY, VALUE);
      return params.toString();
    }
  };

  function init() {
    if (!isStoreMode()) return;
    injectSearchHiddenFields();
    rewriteLinks(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('on:facet-filters:updated', () => {
    rewriteLinks(document.getElementById('filter-results') || document);
  });
})();
